import { render, staticRenderFns } from "./MdCaseList.vue?vue&type=template&id=0bff1a12&scoped=true&"
import script from "./MdCaseList.vue?vue&type=script&lang=js&"
export * from "./MdCaseList.vue?vue&type=script&lang=js&"
import style0 from "./MdCaseList.vue?vue&type=style&index=0&id=0bff1a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bff1a12",
  null
  
)

export default component.exports